import { Input, Form, Button, notification, Modal, Upload } from 'antd';
import { Editor } from '@tinymce/tinymce-react';
import Axios from 'axios';
import { SERVER_URL } from '../../../config/index';
import { useAuth } from '../../../context/useAuth';
import { useNavigate, Link } from 'react-router-dom';
import { useState } from 'react';
import { useRef } from 'react';

const CategoriesForm = props => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { token } = user;
  const [form] = Form.useForm();

  const onFinish = async values => {
    await Axios.post(`${SERVER_URL}/create-category`, values, {
      withCredentials: false,
      headers: { Authorization: `Bearer ${token}` }
    });

    notification.success({
      message: 'Category is created.',
      placement: 'topRight'
    });

    navigate('/admin/grocery/categories');
  };

  return (
    <div className="title-container">
      <Form onFinish={values => onFinish(values)} layout="vertical" form={form}>
        <div className="pl-4 pr-4 d-flex items-center align-center title-blog">
          <p>CREATE NEW CATEGORY</p>
        </div>
        <div className="pl-4 pr-4 d-flex items-center align-center title-blog">
          <Link to={'/admin/grocery/categories'} style={{ color: 'black' }}>
            ALL CATEGORIES
          </Link>
        </div>
        <Form.Item name="name" label="Name">
          <Input type="text" placeholder="Name" className="input-blog-page" />
        </Form.Item>

        <Form.Item name="metaTitle" label="Meta Title">
          <Input
            type="text"
            placeholder="Meta Title"
            className="input-blog-page"
          />
        </Form.Item>

        <Form.Item name="metaDesc" label="Meta Description">
          <Input
            type="text"
            placeholder="Meta Description"
            className="input-blog-page"
          />
        </Form.Item>

        <Button
          htmlType="submit"
          className="btn btn-primary pl-4 pr-4 d-flex items-center align-center"
        >
          Create Category
        </Button>
      </Form>
    </div>
  );
};

export default CategoriesForm;
